// extracted by mini-css-extract-plugin
export default {"root":"tweet-card_root__-z0bc","choice":"tweet-card_choice__UUHtK","bar":"tweet-card_bar__eoZEs","label":"tweet-card_label__RJS9R","percent":"tweet-card_percent__P0RXw"};